import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { instrument_list_loading: true, instrument_list: '', instrument_list_error: false };

export function instrumentList(state = initialState, action) {
  switch (action.type) {
    case organisationConstants.REQUEST_INSTRUMENT_LIST:
      return {
        instrument_list_loading: true,
        instrument_list: '',
        instrument_list_error: false
      };
    case organisationConstants.RESPONSE_INSTRUMENT_LIST:

      return {
        instrument_list_loading: false,
        instrument_list: action.instrument_list,
        instrument_list_error: false
      };
    case organisationConstants.ERROR_INSTRUMENT_LIST:
      return {
        instrument_list_loading: false,
        instrument_list: '',
        instrument_list_error: true
      };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/instrumentList.reducer.js